import api from '../utils/api'

const notesService = {
  // Get all notes with filters and pagination
  getAllNotes: async (params = {}) => {
    try {
      const response = await api.get('/api/notes', { params })
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  // Get note by ID
  getNoteById: async (id) => {
    try {
      const response = await api.get(`/api/notes/${id}`)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  // Create new note
  createNote: async (noteData) => {
    try {
      const response = await api.post('/api/notes', noteData)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  // Update note
  updateNote: async (id, noteData) => {
    try {
      const response = await api.put(`/api/notes/${id}`, noteData)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  // Delete note
  deleteNote: async (id) => {
    try {
      const response = await api.delete(`/api/notes/${id}`)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  // Toggle pin status
  togglePin: async (id) => {
    try {
      const response = await api.put(`/api/notes/${id}/pin`)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  // Get pinned notes
  getPinnedNotes: async () => {
    try {
      const response = await api.get('/api/notes/pinned/list')
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  // Get categories
  getCategories: async () => {
    try {
      const response = await api.get('/api/notes/categories/list')
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  // Search notes by tags
  searchByTags: async (tag) => {
    try {
      const response = await api.get('/api/notes/search/tags', { 
        params: { tag } 
      })
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  }
}

export default notesService